import { createSlice } from "@reduxjs/toolkit";

import {
  getPropertyThunk,
  createPropertyThunk,
  updatePropertyThunk,
  deletePropertyThunk,
} from "state/action/property";

// Initial state
const initialState = {
  // Get Property inisial state
  getProperty: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Create Property inisial state
  createProperty: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update Property inisial state
  updateProperty: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete Property inisial state
  deleteProperty: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  selectedProperty: {
    code: "",
    name: "",
    address: "",
    yearBuild: "",
    description: "",
    status: "",
    base_price: "",
    attachment: [],
  },
  createPropertyInputBody: {
    code: "",
    name: "",
    address: "",
    yearBuild: "",
    description: "",
    status: "",
    attachment: {
      file: "",
      url: "",
    },
  },
  // Property object value
  property_object_value: "",
};

export const propertySlice = createSlice({
  name: "property",
  initialState,
  reducers: {
    setPropertyField: (state, action) => {
      const { field, value } = action.payload;
      state.createPropertyInputBody[field] = value;
    },
    // Menambah file ke array attachment
    addAttachments: (state, action) => {
      state.createPropertyInputBody.attachment = action.payload;
    },
    // Menghapus file dari array attachment
    removeAttachment: (state, action) => {
      state.createPropertyInputBody.attachment = {
        file: "",
        url: "",
      };
    },
    resetPropertyForm: (state) => {
      state.createPropertyInputBody = initialState.createPropertyInputBody;
    },
    setGetPropertyObjectValue: (state, action) => {
      return {
        ...state,
        property_object_value: action.payload,
      };
    },
    // note: clear state
    setClearGetPropertyObjectValue: (state, _) => {
      return {
        ...state,
        property_object_value: "",
      };
    },
    setClearGetproperty: (state, _) => {
      return {
        ...state,
        getProperty: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearCreateProperty: (state, _) => {
      return {
        ...state,
        createProperty: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setCreatePropertyInputBody: (state, action) => {
      return {
        ...state,
        createPropertyInputBody: action.payload,
      };
    },
    setClearCreatePropertyInputBody: (state, _) => {
      return {
        ...state,
        createPropertyInputBody: initialState.createPropertyInputBody,
      };
    },
    setSelectedProperty: (state, action) => {
      return {
        ...state,
        selectedProperty: action.payload,
      };
    },

    setClearUpdateProperty: (state, _) => {
      return {
        ...state,
        updateProperty: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteProperty: (state, _) => {
      return {
        ...state,
        deleteProperty: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllPropertyState: (state, _) => {
      return {
        ...state,
        // Get Property inisial state
        getProperty: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create Property inisial state
        createProperty: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update Property inisial state
        updateProperty: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete Property inisial state
        deleteProperty: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Property object value
        property_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get Property reducer
      .addCase(getPropertyThunk.pending, (state, _) => {
        return {
          ...state,
          getProperty: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getPropertyThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getProperty: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getPropertyThunk.rejected, (state, action) => {
        return {
          ...state,
          getProperty: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create Property reducer
      .addCase(createPropertyThunk.pending, (state, _) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createPropertyThunk.fulfilled, (state, action) => {
        return {
          ...state,
          register: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createPropertyThunk.rejected, (state, action) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update Property reducer
      .addCase(updatePropertyThunk.pending, (state, _) => {
        return {
          ...state,
          updateProperty: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updatePropertyThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateProperty: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updatePropertyThunk.rejected, (state, action) => {
        return {
          ...state,
          updateProperty: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const propertyAction = {
  ...propertySlice.actions,
  getPropertyThunk,
  createPropertyThunk,
  updatePropertyThunk,
  deletePropertyThunk,
};

export function selectPropertyObjectValue(state) {
  return state?.property?.property_object_value;
}

export function selectProperty(state) {
  return state?.property;
}

export default propertySlice.reducer;
